import stomp from 'stompjs';
import HashMap from 'hashmap';
import log from '../../../commons/systemCommon/log.js';
import mqManager from './mqManager.js';
import common from './common.js';
import util from '../../../commons/util.js';
let mqInstanceMap = new HashMap();
let mqConnectMap = new HashMap(); // mq连接实例状态 value  0:连接失败;  1:正在连接; 2:连接成功
let mqInfoMap = new HashMap();
export { mqConnectMap };
export default {
    /**
     * @func  addMqInfo
     * @desc  添加MQ信息
     * @param {object} mqInfo 需要转换的对象
     * @return {boolean} 是否成功
     */
    addMqInfo(mqInfo) {
        if (!util.isEmpty(mqInfo)) {
            mqInfoMap.set(mqInfo.mqId, mqInfo);
            return true;
        }
        return false;
    },
    /**
     * @func  updateMqInfo
     * @desc  修改MQ信息
     * @param {object} mqInfo 需要转换的对象
     * @return {boolean} 是否成功
     */
    updateMqInfo(mqInfo) {
        if (!util.isEmpty(mqInfo)) {
            mqInfoMap.set(mqInfo.mqId, mqInfo);
            return true;
        }
        return false;
    },
    /**
     * @func  removeMqInfoById
     * @desc  根据MqId删除MQ信息
     * @param {string} mqId  消息中间件id
     * @return {boolean} 是否成功
     */
    removeMqInfoById(mqId) {
        if (mqInfoMap.has(mqId)) {
            mqInfoMap.remove(mqId);
            return true;
        }
        return false;
    },
    /**
     * @func  getMqInfoById
     * @desc  根据MqId查询MQ信息
     * @param {string} mqId  消息中间件id
     * @return {object}  mqInfo 消息中间件对象
     */
    getMqInfoById(mqId) {
        return mqInfoMap.get(mqId);
    },
    /**
     * @func  isExistMqInfo
     * @desc  查询MQ对象信息是否存在
     * @param {string} mqId 消息中间件id
     * @return {boolean} 是否存在
     */
    isExistMqInfo(mqId) {
        return mqInfoMap.has(mqId);
    },
    /**
     * @func  cleanMQInfo
     * @desc  清空MQ对象信息
     * @return {object} null
     */
    cleanMQInfo() {
        mqInfoMap.clear();
    },
    mqConnectMapInfo() {
        mqConnectMap.clear();
    },
    /**
     * @func  connectMq
     * @desc  连接MQ
     * @param {string} mqId  消息中间件id
     * @param {object} client  连接实例
     * @return {function} reciveCallBack 订阅消息的回调函数  可选参数
     */
    connectMq(mqId) {
        let connectedFlag = false;
        // 判断mq信息是否存在
        if (!mqInfoMap.has(mqId)) {
            return connectedFlag;
        }
        let mqInfoObj = mqInfoMap.get(mqId);
        // 建立连接对象
        // let socket = new SockJS('http://' + mqInfoObj.ip + ':' + mqInfoObj.port + '/ws')
        let socket = new WebSocket('ws://' + mqInfoObj.ip + ':' + mqInfoObj.webSocketPort + '/ws');

        // 获取STOMP子协议的客户端对象
        let stompClient = stomp.over(socket);
        // 定义客户端的认证信息,按需求配置
        let headers = {
            login: mqInfoObj.user,
            passcode: mqInfoObj.password,
            'client-id': mqId
        };
        //关闭控制台调试数据,stompjs会去检测debug是否是函数，不是函数就不会调用输出
        if (window.config.stompLog) {
            stompClient.debug = null;
        }

        // 向服务器发起websocket连接
        if (stompClient) {
            mqConnectMap.set(mqId, window.vue.$t('connectType.CONNECTING_CODE'));
            stompClient.connect(
                headers,
                () => {
                    // 连接成功的回调函数
                    if (stompClient.connected) {
                        connectedFlag = true;
                        // 连接成功后保存连接实例
                        mqInstanceMap.set(mqId, stompClient);
                        // 连接成功后保存该连接实例的链接状态
                        mqConnectMap.set(mqId, window.vue.$t('connectType.SUCCESS_CODE'));
                        log.info(mqId + window.vue.$t('connectType.SUCCESS'));
                        // 重新订阅
                        mqManager.reSubscribe(mqId);
                    }
                },
                err => {
                    // 连接发生错误时的回调函数
                    if (!stompClient.connected) {
                        mqConnectMap.set(mqId, window.vue.$t('connectType.ERROR_CODE'));
                        log.error(err);
                        log.error(mqId + window.vue.$t('connectType.ERROR'));
                        // 连接发生异常时，去创建恢复连接
                        setTimeout(() => {
                            // 只恢复连接成功的连接实例
                            if (mqInstanceMap.has(mqId) && !mqInstanceMap.get(mqId).connected) {
                                // 创建新的连接
                                let connectFlag = mqManager.connectMq(mqId);
                                // 连接尚未成功时，延时订阅任务
                                setTimeout(function() {}, 1000); // 延迟1秒
                                // 连接成功后，历史订阅任务重新订阅
                                if (connectFlag === window.vue.$t('connectType.SUCCESS_CODE')) {
                                    // 重新订阅
                                    mqManager.reSubscribe(mqId);
                                }
                            }
                        }, 10000);
                    }
                }
            );
        }
        return connectedFlag;
    },
    /**
     * @func  disconnectMq
     * @desc  根据mqId断开MQ连接
     * @param {string} mqId 消息中间件id
     * @return {boolean} 是否成功
     */
    disconnectMq(mqId) {
        if (mqInstanceMap.has(mqId)) {
            mqInstanceMap.get(mqId).disconnect(() => {
                mqInstanceMap.remove(mqId);
            });
        }
    },
    /**
     * @func  isExistMqInstance
     * @desc  查询MQ连接实例是否存在
     * @param {string} mqId 消息中间件id
     * @return {boolean} 是否存在
     */
    isExistMqInstance(mqId) {
        return mqInstanceMap.has(mqId);
    },
    /**
     * @func  getMqInstanceObj
     * @desc  根据MqId获取MQ连接实例信息
     * @param {string} mqId  消息中间件id
     * @return {object}  mqInfo 连接实例对象
     */
    getMqInstanceObj(mqId) {
        return mqInstanceMap.get(mqId);
    },
    /**
     * @func  getAllMqInstanceObj
     * @desc  根据MqId获取MQ连接实例信息
     * @param {string} mqId  消息中间件id
     * @return {object}  mqInfo 连接实例对象
     */
    getAllMqId() {
        return mqInstanceMap.keys();
    }
};
